jQuery(document).ready(function () {
    var menu = $('#dnAdminMenu');
    var toggleClass = 'dnAdminMenu-isOpen';
    if(menu.length) {
        if($(window).width() > 900) {
            menu.toggleClass(toggleClass);
        }
    }

    $(menu).on('transitionend', function() {
        if (menu.hasClass('dnAdminMenu-isOpen')) {
            $(menu).trigger('admin_menu.show.done');
        } else {
            $(menu).trigger('admin_menu.hide.done');
        }
    });
});